"use client";

import { CustomerLoginCodeStepForm } from "@/components/auth/customer-login-code-step-form";
import type { OnboardingIntent } from "@/lib/onboarding/onboarding-intent";
import { useLoginWizard } from "./use-login-wizard";

interface LoginFlowProps {
  maskedEmail: string;
  /** Where to redirect after successful login. Default: /anfitriao/dashboard */
  redirectTo?: string;
  /** Which door this is — a login through the guest door provisions no list. */
  intent: OnboardingIntent;
  onBack: () => void;
}

export function LoginFlow({ maskedEmail, redirectTo, intent, onBack }: LoginFlowProps) {
  const { error, isPending, isResending, actions } = useLoginWizard(redirectTo, intent);

  return (
    <CustomerLoginCodeStepForm
      email={maskedEmail}
      // A CPF already in the base: the code went to the e-mail on file, and back means another CPF.
      known
      backLabel="corrigir o CPF"
      isPending={isPending}
      errorMessage={error}
      onBack={onBack}
      onSubmit={(values) => actions.confirmCode(values)}
      onResend={() => actions.resend()}
      isResending={isResending}
    />
  );
}
